import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import styled, { createGlobalStyle } from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MonthModal = ({ 
    isOpen, 
    toggle, 
    monthData, 
    user, 
    onStart, 
    onComplete 
}) => {
    if (!monthData) return null;

    const isStarted = user && user.modules && user.modules.find(obj => 
        obj.moduleName === monthData.moduleString && !obj.completed
    );
    
    const isCompleted = user && user.modules && user.modules.find(obj => 
        obj.moduleName === monthData.moduleString && obj.completed
    );

    const handleDownload = () => {
        onStart(monthData.moduleString);
    };

    return (
        <>
            <GlobalStyle />
            <StyledModal 
                isOpen={isOpen} 
                toggle={toggle} 
                centered
                backdropClassName="custom-backdrop"
            >
                <ModalHeader toggle={toggle}>
                    {monthData.title}
                    {isCompleted && <StarIcon icon={["fas", "star"]} />}
                </ModalHeader>
                <ModalBody>
                    <CenteredContent>
                        <TopicsSection>
                            <h5>Topics:</h5>
                            <TopicsList>
                                {monthData.topics.map((topic, index) => (
                                    <TopicItem key={index}>{topic}</TopicItem>
                                ))}
                            </TopicsList>
                        </TopicsSection>
                    </CenteredContent>
                </ModalBody>
                <CenteredModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                    <DownloadButton 
                        color="primary" 
                        href={monthData.file} 
                        download
                        onClick={handleDownload}
                    >
                        <FAIconButton icon={["fas", "download"]} />
                        Download PDF
                    </DownloadButton>
                    {isStarted && (
                        <CompleteButton 
                            color="success" 
                            onClick={() => onComplete(monthData.moduleString)}
                        >
                            <FAIconButton icon={["fas", "check"]} />
                            Complete Module
                        </CompleteButton>
                    )}
                </CenteredModalFooter>
            </StyledModal>
        </>
    );
};

export default MonthModal;

const StyledModal = styled(Modal)`
    .modal-header {
        background-color: #9780af;
        color: white;
        border-bottom: 2px solid #372844;
    }
    
    z-index: 1060 !important;
    
    .modal-dialog {
        max-width: 450px;
        width: 90%;
        margin: 0 auto;
        
        @media (max-width: 576px) {
            max-width: 95%;
        }
    }
    
    .modal-content {
        border-radius: 10px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    }
    
    &.modal {
        background-color: rgba(0, 0, 0, 0.7) !important;
    }
`;

// Global style for custom backdrop
const GlobalStyle = createGlobalStyle`
    .custom-backdrop {
        background-color: rgba(0, 0, 0, 0.7) !important;
        z-index: 1055 !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
    }
`;

const CenteredContent = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px 0;
`;

const CenteredModalFooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 15px 20px;
    border-top: 1px solid #dee2e6;
    background-color: #f8f9fa;
`;

const TopicsSection = styled.div`
    padding: 10px 0;
    text-align: center;
    
    h5 {
        color: #372844;
        margin-bottom: 15px;
        font-weight: bold;
    }
`;

const TopicsList = styled.ul`
    list-style-type: disc;
    display: inline-block;
    text-align: left;
    padding-left: 20px;
    margin-bottom: 0;
`;

const TopicItem = styled.li`
    font-size: 1rem;
    margin-bottom: 8px;
    color: #333;
`;

const DownloadButton = styled(Button)`
    margin-right: 10px;
`;

const CompleteButton = styled(Button)`
    background-color: #28a745;
    border-color: #28a745;
    
    &:hover {
        background-color: #218838;
        border-color: #1e7e34;
    }
`;

const FAIconButton = styled(FontAwesomeIcon)`
    margin-right: 8px;
`;

const StarIcon = styled(FontAwesomeIcon)`
    margin-left: 10px;
    color: gold;
    font-size: 1.2em;
`;